module.exports = __webpack_public_path__ + "img/logo_white.32bbf6c6.png";